<template xmlns="http://www.w3.org/1999/html">
	<div>
		<el-row>
			<el-col>
				<el-form :inline='true'>
					<!--					<el-form-item label="关键字:">-->
					<!--						<el-input v-model="filters.keyWord" @input="(e) => (filters.keyWord = utils.validForbid(e))" placeholder="项目编号/项目名称" clearable></el-input>-->
					<!--					</el-form-item>-->
					<el-form-item label="省份:">
						<el-select v-model="filters.provinceCode" @change="changeSearchProvince" filterable clearable>
							<el-option v-for="item in provinceSearchOptions" :key="item.id" :label="item.name"
							           :value="item.code"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="城市:">
						<el-select v-model="filters.cityCode"  filterable clearable>
							<el-option v-for="item in citySearchOptions" :key="item.id" :label="item.name"
							           :value="item.code"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="报告出具开始时间：">
						<el-date-picker
								v-model="filters.startData"
								format="yyyy-MM-dd"
								value-format="yyyy-MM-dd"
						>
						</el-date-picker>
					</el-form-item>
					<el-form-item label="报告出具结束时间：">
						<el-date-picker
								v-model="filters.endData"
								format="yyyy-MM-dd"
								value-format="yyyy-MM-dd"
						>
						</el-date-picker>
					</el-form-item>
<!--					<el-form-item label="">-->
<!--						<el-select v-model="filters.userAi" placeholder="提交者" clearable>-->
<!--							<el-option-->
<!--									v-for="item in entyTypeArr"-->
<!--									:key="item.value"-->
<!--									:label="item.name"-->
<!--									:value="item.value"-->
<!--							>-->
<!--							</el-option>-->
<!--						</el-select>-->
<!--					</el-form-item>-->
					<el-form-item>
						<toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
					</el-form-item>
				</el-form>
			</el-col>
		</el-row>
		<!-- 列表 -->
		<el-table
				:data="tableData"
				border
				id="exportTab"
				style="width: 100%"
				v-loading="listLoading"
				ref="multipleTable"
				@current-change='currentChange'
				:highlight-current-row='true'
		>
			<el-table-column type='index' label="序号" width='60' align="center" :index='indexMethod'></el-table-column>
			<el-table-column prop="projectName" label="项目名称" align="center" width="520" show-overflow-tooltip>
				<template slot-scope="scope" >
						<div>
							<el-button v-if="scope.row.projectName !=='合计（去重）'" type="text" slot="reference" @click="onPreview(scope.row)">{{scope.row.projectName}}</el-button>
							<div v-else>{{scope.row.projectName}}</div>
						</div>
				</template>
			</el-table-column>
			<el-table-column prop="itemRepeats" label="审查总数" align="center" width="" show-overflow-tooltip>
			</el-table-column>
<!--			<el-table-column prop="humanInSmallAiStandard" label="53范围总数" align="center" width="" show-overflow-tooltip>-->
			<el-table-column prop="aiTotalNum" label="AI提交总数" align="center" width="" show-overflow-tooltip>
			
			</el-table-column>
			<el-table-column prop="aiReportMiddleAiStandardTotalNum" label="AI被采纳数量" align="center" width="" show-overflow-tooltip></el-table-column>
			<el-table-column prop="aiIsDevelopmentNum" label="AI已研发范围数量" align="center" width="" show-overflow-tooltip></el-table-column>
			<el-table-column prop="aiIsDevelopmentHumanNum" label="AI已研发范围人工采纳数量" align="center" width="230" show-overflow-tooltip></el-table-column>
			<el-table-column prop="aiIsDevelopmentAiReportNum" label="AI已研发范围AI被采纳" align="center" width="" show-overflow-tooltip></el-table-column>

			
<!--			</el-table-column>-->
		</el-table>
		<!--底部工具条-->
<!--		<el-col :span="24" class="pageBar">-->
<!--			<el-pagination-->
<!--					@size-change="handleSizeChange"-->
<!--					@current-change="handleCurrentChange"-->
<!--					:current-page="pages.pageIndex"-->
<!--					:page-sizes="pages.pageArr"-->
<!--					:page-size="pages.pageSize"-->
<!--					layout="total, sizes, prev, pager, next, jumper"-->
<!--					:total="pages.dataCount">-->
<!--			</el-pagination>-->
<!--		</el-col>-->
		<el-dialog
				title=""
				:visible.sync="dialogDetailVisible"
				v-model="dialogDetailVisible"
				:close-on-click-modal="false"
				:destroy-on-close="true"
				width='90%'
		>
			<!-- 列表 -->
			<el-table
					:data="tableDataDetail"
					border
					id="exportTab"
					style="width: 100%"
					v-loading="listLoading"
					ref="multipleTable"
					@current-change='currentChange'
					:highlight-current-row='true'
			>
				<el-table-column type='index' label="序号" width='60' align="center" :index='indexMethod'></el-table-column>
				<el-table-column prop="projectName" label="项目名称" align="center" width="" show-overflow-tooltip></el-table-column>
				<el-table-column prop="confirmProblem" label="意见内容" align="center" show-overflow-tooltip></el-table-column>
				<el-table-column prop="drStandardItemDescribe" label="规范条文" align="center" show-overflow-tooltip></el-table-column>
				<el-table-column prop="createTime" label="提交时间" align="center" width="160" show-overflow-tooltip></el-table-column>
				<el-table-column prop="idReport" label="是否采纳" align="center" width="62" show-overflow-tooltip>
					<template slot-scope="scope">
						<el-tag v-if="scope.row.isReport === true"  type="primary">{{'是'}}</el-tag>
						<el-tag v-else-if="scope.row.isReport === false" type="danger">{{'否'}}</el-tag>
						<el-tag v-else type="warning">{{'无'}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="areaName" label="提交者" align="center" width="73" show-overflow-tooltip>
					<template slot-scope="scope">
						<el-tag v-if="scope.row.userIsAi === 0"  type="success">{{'人工'}}</el-tag>
						<el-tag v-else type="">&nbsp;&nbsp;{{'AI'}}&nbsp;&nbsp;</el-tag>
					</template>
				</el-table-column>
<!--				<el-table-column prop="standardIsAi" label="247范围" width="62" align="center" show-overflow-tooltip>-->
<!--					<template slot-scope="scope">-->
<!--						<el-tag v-if="scope.row.standardIsAi === true"  type="primary">{{'是'}}</el-tag>-->
<!--						<el-tag v-else type="danger">{{'否'}}</el-tag>-->
<!--						&lt;!&ndash;					<el-tag v-else type="warning">{{'无'}}</el-tag>&ndash;&gt;-->
<!--					</template>-->
<!--				</el-table-column>-->
				<el-table-column prop="standardIsMiddleAi" label="139范围" width="62" align="center" show-overflow-tooltip>
					<template slot-scope="scope">
						<el-tag v-if="scope.row.standardIsMiddleAi === true"  type="primary">{{'是'}}</el-tag>
						<el-tag v-else type="danger">{{'否'}}</el-tag>
						<!--					<el-tag v-else type="warning">{{'无'}}</el-tag>-->
					</template>
				</el-table-column>
				<el-table-column prop="standardIsAi" label="事项" width="100" align="center" show-overflow-tooltip>
					<template slot-scope="scope">
						<el-tag v-if="scope.row.itemType === 1"  type="danger">{{'重要事项'}}</el-tag>
						<el-tag v-else-if="scope.row.itemType === 9"  type="warning">{{'其他事项'}}</el-tag>
						<el-tag v-else type="primary">{{'-'}}</el-tag>
						<!--					<el-tag v-else type="warning">{{'无'}}</el-tag>-->
					</template>
				</el-table-column>
				
				<el-table-column prop="isDevelopmentAi" label="AI已研发范围" width="80" align="center" show-overflow-tooltip>
					<template slot-scope="scope">
						<el-tag v-if="scope.row.isDevelopmentAi === 0"  type="danger">{{'不研发'}}</el-tag>
						<el-tag v-else-if="scope.row.isDevelopmentAi === 1"  type="primary">{{'已研发'}}</el-tag>
						<el-tag v-else-if="scope.row.isDevelopmentAi === 2"  type="warning">{{'待研发'}}</el-tag>
						<el-tag v-else type="info">{{'-'}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="isDetectAi" label="AI可检出" width="62" align="center" show-overflow-tooltip>
					<template slot-scope="scope">
						<el-tag v-if="scope.row.isDetectAi === true"  type="primary">{{'是'}}</el-tag>
						<el-tag v-else type="danger">{{'否'}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="drQuestionId" label="问题编号" width="66" align="center" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="fileList" label="问题截图" width="60" align="center" show-overflow-tooltip>
					<template slot-scope="scope">
						<el-button @click="onPreviewProblem(scope.row)" type="text" size="small">查看</el-button>
					</template>
				</el-table-column>
			
			</el-table>
			<!--底部工具条-->
			<div class="pageBar">
				<el-col :span="24" >
					<el-pagination
							@size-change="handleSizeChangeDetail"
							@current-change="handleCurrentChangeDetail"
							:current-page="pagesDetail.pageIndex"
							:page-sizes="pagesDetail.pageArr"
							:page-size="pagesDetail.pageSize"
							layout="total, sizes, prev, pager, next, jumper"
							:total="pagesDetail.dataCount">
					</el-pagination>
				</el-col>
			</div>
		</el-dialog>
		<el-dialog :visible.sync="previewFalse" title="截图查看" width="50%"  @close="previewFalse=false">
			<template  >
				<div class="file-list-wrapper">
					<div v-for="(url,index) in fileList" >
						{{index+1+'、'+url.split(',')[0]}}
						<el-image  :key="url" :src="url.split(',')[1]" lazy></el-image>
					</div>
				</div>
			</template>
		</el-dialog>
	</div>
</template>

<script>
import util from "../../../util/date";
import Toolbar from "../../components/Toolbar";
import { getButtonList } from "../../promissionRouter";
import {
	getAreaDictionaryByCode, getAreaDictionaryList, getByNamespace,
	getStatisticsKYJCAiStandardData,
	getStatisticsKYJCOpininDetail,
	
} from '@/api/api'
import * as XLSX from "xlsx";
import FileSaver from 'file-saver'

export default {
	components:{Toolbar},
	data() {
		return {
			fileList: [],
			entyTypeArr:[
				{
					name:'AI',
					value:true
				},
				{
					name:'人工',
					value:false
				}
			],
			dialogDetailVisible:false,
			utils: '',
			buttonList: [],
			needData: [],
			citySearchOptions:undefined,
			provinceSearchOptions:undefined,
			regionSearchOptions:undefined,
			filters: {
				startData:undefined,
				endData:undefined,
				timeData:[],
				userAi:undefined,
				cityCode:undefined,
				provinceCode:undefined,
			},
			tableData: [],
			tableDataDetail: [],
			areaArr: [],
			listLoading: false,
			//关于分页的obj
			pages: {
				pageSize: 20,//默认每页条数
				pageArr: [20, 50, 100, 300],//默认每页条数选择
				pageIndex: 1, //默认进入页
				dataCount: 20, //默认总页数
			},
			pagesDetail: {
				pageSize: 20,//默认每页条数
				pageArr: [20, 50, 100, 300],//默认每页条数选择
				pageIndex: 1, //默认进入页
				dataCount: 20, //默认总页数
			},
			previewFalse:false,
		}
	},
	methods: {
		onPreviewProblem(value){
			this.fileList = value.fileList
			this.previewFalse=true
		},
		// 分页
		handleCurrentChangeDetail(val) {
			console.log(val,'分页')
			this.pages.pageIndex = val;
			this.getDataList();
		},
		handleSizeChangeDetail(val){
			this.pages.pageSize = val;
			this.getDataList();
		},
		// 列表查询接口
		async getDataListDetail(row){
			console.log(this.filters.timeData,'timeData')
			let params = {
				pageIndex: this.pagesDetail.pageIndex,
				pageSize: this.pagesDetail.pageSize,
				startData:this.filters.startData,
				endData:this.filters.endData,
				userIsAi:this.filters.userAi,
				projectName:row.projectName||undefined,
				confirmProblem:this.filters.confirmProblem||undefined,
			}
			this.listLoading = true
			const res = await getStatisticsKYJCOpininDetail(params)
			const result = res.data;
			if(result.success) {
				this.tableDataDetail = result.response.data
				this.pagesDetail.dataCount = result.response.dataCount
				this.dialogDetailVisible = true
			}
			this.listLoading = false
			
		},
		onPreview (row) {
			this.getDataListDetail(row)
			
			
		},
		async init() {
			//   获取所有省份 获取特长
			const initResult = await Promise.all([
				// getByNamespace({ namespace: 'CommonService.OrgPermission.ExpertIdentity' }),
				getAreaDictionaryList({ parentId: 1 }),
				getByNamespace({ namespace: 'CommonService.OrgPermission.ExpertExpertise' }),
			])
			const [provinceRes, expertiseRes] = initResult;
			
			if (provinceRes.data.success) {
				this.provinceSearchOptions = provinceRes.data.response.reverse();
			}
			
		},
		// 省切换
		changeSearchProvince(code) {
			this.filters.cityCode = undefined;
			this.filters.regionCode = undefined;
			this.citySearchOptions = [];
			this.regionSearchOptions = [];
			getAreaDictionaryByCode({ code: code,isEnable : true  }).then(res => {
				var result = res.data
				if (result.success) {
					var id = result.response.id;
					getAreaDictionaryList({ parentId: id }).then(res => {
						if (res.data.success) {
							this.citySearchOptions = res.data.response.reverse();
						}
					})
				}
			})
		},
		//导出
		async exportListData () {
			let wb = XLSX.utils.book_new();
			// 导出主表格
			let mainTable = document.querySelector('#exportTab');
			let xlsxParam = { raw: true };
			let mainSheet = XLSX.utils.table_to_sheet(mainTable, xlsxParam);
			XLSX.utils.book_append_sheet(wb, mainSheet, '审查情况分析');
			// 从多个子表格中导出数据
			// for (let item of this.tableData) {
			// 	this.tableDataList.projectList = [];
			// 	// 显示当前子表格的对话框
			// 	this.getProject(item)
			// 	// 等待对话框完全渲染（您可能需要实现这一部分）
			// 	await this.$nextTick();
			// 	let oneTable = document.querySelector('#personal');
			// 	let oneSheet = XLSX.utils.table_to_sheet(oneTable, xlsxParam);
			// 	// 在Excel工作表中使用唯一名称来标识每个子表格
			// 	XLSX.utils.book_append_sheet(wb, oneSheet, `子表-${item.userName}`);
			// 	// 关闭当前子表格的对话框
			// 	this.dialog.project.show = false;
			// }
			// 将工作簿导出为Excel文件
			let wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' });
			try {
				FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '审查情况分析（开业检查）.xlsx');
			} catch (e) {
				if (typeof console !== 'undefined') {
					console.log(e, wbout);
				}
			}
			return wbout;
		},
		rowClass () {
			return 'padding:8px!important;'
		},
		callFunction(item) {
			this[item.func].apply(this, item);
		},
		// 列表查询接口
		getDataList(){
			console.log(this.filters.timeData,'timeData')
			let params = {
				// pageIndex: this.pages.pageIndex,
				// pageSize: this.pages.pageSize,
				provinceCode: this.filters.provinceCode,
				cityCode: this.filters.cityCode,
				startData:this.filters.startData,
				endData:this.filters.endData,
				// userIsAi:this.filters.userAi,
			}
			this.listLoading = true
			getStatisticsKYJCAiStandardData(params).then(res => {
				const result = res.data;
				if(result.success) {
					// this.tableData = result.response
					this.tableData = this.addPropertySumsToOriginalTotal(result.response)
					// this.pages.dataCount = result.response.dataCount
				}
				this.listLoading = false
			})
		},
		addPropertySumsToOriginalTotal(arr) {
			const sumObj = {};
			const lastObj = arr[arr.length - 1];
			
			// 遍历数组，累加每个属性的值
			for (let i = 0; i < arr.length - 1; i++) {
				const obj = arr[i];
				for (const key in obj) {
					if (obj.hasOwnProperty(key)&& key!== 'projectName') {
						if (sumObj[key]) {
							sumObj[key] += obj[key];
						} else {
							sumObj[key] = obj[key];
						}
					}
				}
			}
			
			// 将计算结果添加到原合计数据中
			for (const key in sumObj) {
				if (sumObj.hasOwnProperty(key)) {
					// lastObj[key] = `${sumObj[key]} (${lastObj[key]})`;
					lastObj[key] = `${sumObj[key]}`;
				}
			}
			console.log(arr,'arr')
			return arr;
		},
		// 查询
		getListData() {
			this.pages.pageIndex = 1
			this.getDataList();
		},
		
		// 点击table某一行
		currentChange(val) {
			this.needData = val
			console.log(val,'val')
			
		},
		// 分页
		handleCurrentChange(val) {
			this.pages.pageIndex = val;
			this.getListData();
		},
		handleSizeChange(val){
			this.pages.pageSize = val;
			this.getListData();
		},
		// 时间格式化
		formatCreateTime: function(row, column) {
			return !row || row == ""
					? ""
					: util.formatDate.format(new Date(row), "yyyy-MM-dd hh:mm");
		},
		// 表格数据分页条数累计
		indexMethod(index) {
			var currentPage = this.pages.pageIndex
			var pageSize = this.pages.pageSize
			return (index + 1) + (currentPage - 1) * pageSize
		},
	},
	watch: {
	
	},
	created(){
		const currentDate = new Date();
		const year = currentDate.getFullYear();
		const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以需要+1
		const day = String(currentDate.getDate()).padStart(2, '0');
		
		const formattedDate = `${year}-${month}-${day}`;
		this.filters.startData = formattedDate
		this.filters.endData = formattedDate
		console.log(formattedDate,'formattedDate')
		this.init();
		this.utils = util
		let routers = window.localStorage.router
				? JSON.parse(window.localStorage.router)
				: [];
		this.buttonList = getButtonList(this.$route.path, routers);
		this.getListData();
	}
}
</script>

<style lang="stylus" scoped>
.pageBar{
	padding: 10px 0;
}
.projectName {
	text-align: center;
}
.projectSelect {
	margin-bottom: 15px;
}
.projectTitle {
	margin-bottom: 15px
}
.replyBtn {
	margin: 10px 0;
	color: #409eff;
	cursor: pointer;
	width: 30px;
}
.replyMessage {
	background: #eee;
	line-height: 30px;
	padding: 5px;
	border-radius: 2px;
	margin: 5px 15px;
}
.titleTimer {
	margin-left: 10px;
}
.green_t {
	color: green;
}
.red_t {
	color: red;
}
</style>
